import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import gql from 'graphql-tag';

import { GetOnsiteWorkersForOrg } from '../../athena/types/GetOnsiteWorkersForOrg';
import { MemberFields } from '../../fragments/directory/Member';

export const QUERY = gql`
  query GetOnsiteWorkersForOrg($orgId: String!) {
    webMaintenance {
      getOnsiteWorkersForOrg(input: { organizationId: $orgId }) {
        members {
          ...MemberFields
        }
      }
    }
  }
  ${MemberFields}
`;

const useGetOnsiteWorkersForOrg = (options?: QueryHookOptions<GetOnsiteWorkersForOrg>) =>
  useQuery<GetOnsiteWorkersForOrg>(QUERY, options);

export default useGetOnsiteWorkersForOrg;
